var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "box mt-10" },
      [
        _c(
          "md-card",
          [
            _c(
              "md-card-expand",
              [
                _c(
                  "md-card-actions",
                  { attrs: { "md-alignment": "space-between" } },
                  [
                    _c(
                      "md-card-expand-trigger",
                      [
                        _c(
                          "md-button",
                          { staticClass: "community-expand-button m-left-5" },
                          [
                            _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.expandchannel("8")
                                  }
                                }
                              },
                              [_vm._v("Content")]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "md-card-expand-content",
                  [
                    _c("md-card-content", { staticClass: "card-content" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.opened.includes("8"),
                              expression: "opened.includes('8')"
                            }
                          ],
                          class: { opened: _vm.opened.includes("8") }
                        },
                        [
                          _c(
                            "form",
                            {
                              attrs: { "data-vv-scope": "form-content" },
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.addContent("form-content")
                                },
                                change: function($event) {
                                  _vm.saveContentText = "save"
                                }
                              }
                            },
                            [
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Thank you page")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    attrs: {
                                      name: "thank you",
                                      placeholder: "Thank You URL"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.thankYouURL = _vm.sanitizeURL(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.thankYouURL,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "thankYouURL",
                                          $$v
                                        )
                                      },
                                      expression: "content.thankYouURL"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.thank you"
                                      ),
                                      expression:
                                        "errors.has('form-content.thank you')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first("form-content.thank you")
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Landing page")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    attrs: {
                                      name: "landing page",
                                      placeholder: "Landing Page URL"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.landingPageURL = _vm.sanitizeURL(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.landingPageURL,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "landingPageURL",
                                          $$v
                                        )
                                      },
                                      expression: "content.landingPageURL"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.landing page"
                                      ),
                                      expression:
                                        "errors.has('form-content.landing page')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.landing page"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Terms & Conditions URL")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    attrs: {
                                      name: "terms condition",
                                      placeholder: "Terms & Conditions URL"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.termsConditionsURL = _vm.sanitizeURL(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.termsConditionsURL,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "termsConditionsURL",
                                          $$v
                                        )
                                      },
                                      expression: "content.termsConditionsURL"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.terms condition"
                                      ),
                                      expression:
                                        "errors.has('form-content.terms condition')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.terms condition"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Frequently Asked Questions")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    attrs: {
                                      name: "frequently ask",
                                      placeholder:
                                        "Frequently Asked Questions URL"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.frequentlyAskQuestionsURL = _vm.sanitizeURL(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value:
                                        _vm.content.frequentlyAskQuestionsURL,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "frequentlyAskQuestionsURL",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "content.frequentlyAskQuestionsURL"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.frequently ask"
                                      ),
                                      expression:
                                        "errors.has('form-content.frequently ask')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.frequently ask"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Tips & Best Practices")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    attrs: {
                                      name: "tips",
                                      placeholder: "Tips & Best Practices"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.tips = _vm.sanitizeURL(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.tips,
                                      callback: function($$v) {
                                        _vm.$set(_vm.content, "tips", $$v)
                                      },
                                      expression: "content.tips"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.unsubscribePageURL"
                                      ),
                                      expression:
                                        "errors.has('form-content.unsubscribePageURL')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.unsubscribePageURL"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Unsubscribe Page URL")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    staticClass: "not-allowed",
                                    attrs: {
                                      name: "unsubscribe page",
                                      readonly: "",
                                      placeholder: "Unsubscribe Page URL"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.unsubscribePageURL = _vm.sanitizeURL(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.unsubscribePageURL,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "unsubscribePageURL",
                                          $$v
                                        )
                                      },
                                      expression: "content.unsubscribePageURL"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("hr", { staticClass: "dark-border m-left-5" }),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v(
                                      'Parameter 1: Member Affinity Name ("Blue Devil")'
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:100",
                                        expression: "'max:100'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxParameters,
                                      name: "parameter1",
                                      placeholder:
                                        'Parameter 1: Member Affinity Name ("Blue Devil")'
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.parameter1 = _vm.sanitizeInput(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.parameter1,
                                      callback: function($$v) {
                                        _vm.$set(_vm.content, "parameter1", $$v)
                                      },
                                      expression: "content.parameter1"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.parameter1"
                                      ),
                                      expression:
                                        "errors.has('form-content.parameter1')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.parameter1"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v(
                                      'Parameter 2: Community Name ("Ask A Blue Devil")'
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:100",
                                        expression: "'max:100'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxParameters,
                                      name: "parameter2",
                                      placeholder:
                                        'Parameter 2: Community Name ("Ask A Blue Devil")'
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.parameter2 = _vm.sanitizeInput(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.parameter2,
                                      callback: function($$v) {
                                        _vm.$set(_vm.content, "parameter2", $$v)
                                      },
                                      expression: "content.parameter2"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.parameter2"
                                      ),
                                      expression:
                                        "errors.has('form-content.parameter2')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.parameter2"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v(
                                      'Parameter 3: Member Affinity Name ("a fellow Blue Devil")'
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:100",
                                        expression: "'max:100'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxParameters,
                                      name: "parameter3",
                                      placeholder:
                                        'Parameter 3: Member Affinity Name ("a fellow Blue Devil")'
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.parameter3 = _vm.sanitizeInput(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.parameter3,
                                      callback: function($$v) {
                                        _vm.$set(_vm.content, "parameter3", $$v)
                                      },
                                      expression: "content.parameter3"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.parameter3"
                                      ),
                                      expression:
                                        "errors.has('form-content.parameter3')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.parameter3"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v(
                                      'Parameter 4: Organization Name ("Duke")'
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:100",
                                        expression: "'max:100'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxParameters,
                                      name: "parameter4",
                                      placeholder:
                                        'Parameter 4: Organization Name ("Duke")'
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.parameter4 = _vm.sanitizeInput(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.parameter4,
                                      callback: function($$v) {
                                        _vm.$set(_vm.content, "parameter4", $$v)
                                      },
                                      expression: "content.parameter4"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.parameter4"
                                      ),
                                      expression:
                                        "errors.has('form-content.parameter4')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.parameter4"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v(
                                      'Parameter 5: Member Name ("student")'
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:100",
                                        expression: "'max:100'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxParameters,
                                      name: "parameter5",
                                      placeholder:
                                        'Parameter 5: Member Name ("student")'
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.parameter5 = _vm.sanitizeInput(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.parameter5,
                                      callback: function($$v) {
                                        _vm.$set(_vm.content, "parameter5", $$v)
                                      },
                                      expression: "content.parameter5"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.parameter5"
                                      ),
                                      expression:
                                        "errors.has('form-content.parameter5')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.parameter5"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v('Parameter 6: Advisor Name ("alum")')
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:100",
                                        expression: "'max:100'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxParameters,
                                      name: "parameter6",
                                      placeholder:
                                        'Parameter 6: Advisor Name ("alum")'
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.parameter6 = _vm.sanitizeInput(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.parameter6,
                                      callback: function($$v) {
                                        _vm.$set(_vm.content, "parameter6", $$v)
                                      },
                                      expression: "content.parameter6"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.parameter6"
                                      ),
                                      expression:
                                        "errors.has('form-content.parameter6')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.parameter6"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Parameter 7")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:100",
                                        expression: "'max:100'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxParameters,
                                      name: "parameter7",
                                      placeholder: "Parameter 7"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.parameter7 = _vm.sanitizeInput(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.parameter7,
                                      callback: function($$v) {
                                        _vm.$set(_vm.content, "parameter7", $$v)
                                      },
                                      expression: "content.parameter7"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.parameter7"
                                      ),
                                      expression:
                                        "errors.has('form-content.parameter7')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.parameter7"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Parameter 8")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:100",
                                        expression: "'max:100'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxParameters,
                                      name: "parameter8",
                                      placeholder: "Parameter 8"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.parameter8 = _vm.sanitizeInput(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.parameter8,
                                      callback: function($$v) {
                                        _vm.$set(_vm.content, "parameter8", $$v)
                                      },
                                      expression: "content.parameter8"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.parameter8"
                                      ),
                                      expression:
                                        "errors.has('form-content.parameter8')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.parameter8"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("hr", { staticClass: "dark-border m-left-5" }),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Response Engagement Tips")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: false,
                                          regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_]*)?$/
                                        },
                                        expression:
                                          "{ required: false, regex: /^http(s?)\\:\\/\\/[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*(:(0-9)*)*(\\/?)([a-zA-Z0-9\\-\\.\\?\\,\\'\\/\\\\\\+&%\\$#_]*)?$/ }"
                                      }
                                    ],
                                    attrs: {
                                      name: "responseEngagementTip",
                                      placeholder: "Response Engagement Tips"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.responseEngagementTip = _vm.sanitizeURL(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.responseEngagementTip,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "responseEngagementTip",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "content.responseEngagementTip"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "md-helper-text" },
                                    [
                                      _c("strong", [_vm._v("Note:")]),
                                      _vm._v(
                                        " Response engagement tip URL for i.e https://www.example.com"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.errors.has(
                                "form-content.responseEngagementTip"
                              )
                                ? _c(
                                    "p",
                                    { staticClass: "error m-left-5 m-top-20" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errors.first(
                                            "form-content.responseEngagementTip"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                [
                                  _c("label", [_vm._v("Welcome Adviser")]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:5000",
                                        expression: "'max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "welcomeadviser",
                                      placeholder: "Welcome Adviser"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.welcomeadviser = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.welcomeadviser,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "welcomeadviser",
                                          $$v
                                        )
                                      },
                                      expression: "content.welcomeadviser"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.welcomeadviser"
                                      ),
                                      expression:
                                        "errors.has('form-content.welcomeadviser')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.welcomeadviser"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                [
                                  _c("label", [_vm._v("Welcome Member")]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:5000",
                                        expression: "'max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "welcomemember",
                                      placeholder: "Welcome member"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.welcomemember = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.welcomemember,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "welcomemember",
                                          $$v
                                        )
                                      },
                                      expression: "content.welcomemember"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.welcomemember"
                                      ),
                                      expression:
                                        "errors.has('form-content.welcomemember')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.welcomemember"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                [
                                  _c("label", [_vm._v("Referral Message")]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "required|max:5000",
                                        expression: "'required|max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "referralMessage",
                                      placeholder: "Referral Message"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.referralMessage = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.referralMessage,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "referralMessage",
                                          $$v
                                        )
                                      },
                                      expression: "content.referralMessage"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.referralMessage"
                                      ),
                                      expression:
                                        "errors.has('form-content.referralMessage')"
                                    }
                                  ],
                                  staticClass:
                                    "error m-left-5 error-custom-position"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.referralMessage"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                [
                                  _c("label", [
                                    _vm._v("Request Form Wizard - Page 1")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:5000",
                                        expression: "'max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "coach",
                                      placeholder:
                                        "Request Form Wizard - Page 1"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.requestIntroduction = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.requestIntroduction,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "requestIntroduction",
                                          $$v
                                        )
                                      },
                                      expression: "content.requestIntroduction"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.coach"
                                      ),
                                      expression:
                                        "errors.has('form-content.coach')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first("form-content.coach")
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                [
                                  _c("label", [
                                    _vm._v("Request Form Wizard - Page 2")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:5000",
                                        expression: "'max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "requestFormWizardPage2",
                                      placeholder:
                                        "Request Form Wizard - Page 2"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.requestFormWizardPage2 = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.requestFormWizardPage2,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "requestFormWizardPage2",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "content.requestFormWizardPage2"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.requestFormWizardPage2"
                                      ),
                                      expression:
                                        "errors.has('form-content.requestFormWizardPage2')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.requestFormWizardPage2"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                [
                                  _c("label", [
                                    _vm._v("Request Form Wizard - Page 3")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:5000",
                                        expression: "'max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "requestFormWizardPage3",
                                      placeholder:
                                        "Request Form Wizard - Page 3"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.requestFormWizardPage3 = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.requestFormWizardPage3,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "requestFormWizardPage3",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "content.requestFormWizardPage3"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.requestFormWizardPage3"
                                      ),
                                      expression:
                                        "errors.has('form-content.requestFormWizardPage3')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.requestFormWizardPage3"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-rule" },
                                [
                                  _c("label", [
                                    _vm._v("Request Form Wizard - Page 4")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "required|max:5000",
                                        expression: "'required|max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "formThankyou",
                                      placeholder:
                                        "Request Form Wizard - Page 4"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.requestPageThankYou = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.requestPageThankYou,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "requestPageThankYou",
                                          $$v
                                        )
                                      },
                                      expression: "content.requestPageThankYou"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.formThankyou"
                                      ),
                                      expression:
                                        "errors.has('form-content.formThankyou')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.formThankyou"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                [
                                  _c("label", [
                                    _vm._v("Request Coaching Message")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:5000",
                                        expression: "'max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "coach",
                                      placeholder: "Request Coaching Message"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.coach = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.coach,
                                      callback: function($$v) {
                                        _vm.$set(_vm.content, "coach", $$v)
                                      },
                                      expression: "content.coach"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.coach"
                                      ),
                                      expression:
                                        "errors.has('form-content.coach')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first("form-content.coach")
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                [
                                  _c("label", [
                                    _vm._v("Response Coaching Message")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:5000",
                                        expression: "'max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "responseCoach",
                                      placeholder: "Response Coaching Message"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.responseCoach = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.responseCoach,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "responseCoach",
                                          $$v
                                        )
                                      },
                                      expression: "content.responseCoach"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.responseCoach"
                                      ),
                                      expression:
                                        "errors.has('form-content.responseCoach')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.responseCoach"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                [
                                  _c("label", [
                                    _vm._v("Action Form - Advice Tips")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:5000",
                                        expression: "'max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "actionFormAdviceTips",
                                      placeholder: "Action Form - Advice Tips"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.actionFormAdviceTips = _vm.sanitizeActionFormTips(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.actionFormAdviceTips,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "actionFormAdviceTips",
                                          $$v
                                        )
                                      },
                                      expression: "content.actionFormAdviceTips"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.actionFormAdviceTips"
                                      ),
                                      expression:
                                        "errors.has('form-content.actionFormAdviceTips')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.actionFormAdviceTips"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                [
                                  _c("label", [
                                    _vm._v("Action Form - Call Tips")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:5000",
                                        expression: "'max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "actionFormCallTips",
                                      placeholder: "Action Form - Call Tips"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.actionFormCallTips = _vm.sanitizeActionFormTips(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.actionFormCallTips,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "actionFormCallTips",
                                          $$v
                                        )
                                      },
                                      expression: "content.actionFormCallTips"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.actionFormCallTips"
                                      ),
                                      expression:
                                        "errors.has('form-content.actionFormCallTips')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.actionFormCallTips"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                [
                                  _c("label", [
                                    _vm._v("Action Form - Meeting Tips")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:5000",
                                        expression: "'max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "actionFormMeetingTips",
                                      placeholder: "Action Form - Meeting Tips"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.actionFormMeetingTips = _vm.sanitizeActionFormTips(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.actionFormMeetingTips,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "actionFormMeetingTips",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "content.actionFormMeetingTips"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.actionFormMeetingTips"
                                      ),
                                      expression:
                                        "errors.has('form-content.actionFormMeetingTips')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.actionFormMeetingTips"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                [
                                  _c("label", [
                                    _vm._v("Request Form Confirmation")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:5000",
                                        expression: "'max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "formConfirmation",
                                      placeholder: "Request Form Confirmation"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.formConfirmation = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.formConfirmation,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "formConfirmation",
                                          $$v
                                        )
                                      },
                                      expression: "content.formConfirmation"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.formConfirmation"
                                      ),
                                      expression:
                                        "errors.has('form-content.formConfirmation')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.formConfirmation"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-rule" },
                                [
                                  _c("label", [
                                    _vm._v("Feedback Request Message")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:5000",
                                        expression: "'max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "formFeedbackRequestMessage",
                                      placeholder: "Feedback Request Message"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.feedbackRequestMessage = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.feedbackRequestMessage,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "feedbackRequestMessage",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "content.feedbackRequestMessage"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.formFeedbackRequestMessage"
                                      ),
                                      expression:
                                        "errors.has('form-content.formFeedbackRequestMessage')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.formFeedbackRequestMessage"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-rule" },
                                [
                                  _c("label", [
                                    _vm._v("Donor Alert Introduction")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:5000",
                                        expression: "'max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "donorAlertMessage",
                                      placeholder: "Donor Alert Message"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.donorAlertMessage = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.donorAlertMessage,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "donorAlertMessage",
                                          $$v
                                        )
                                      },
                                      expression: "content.donorAlertMessage"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.donorAlertMessage"
                                      ),
                                      expression:
                                        "errors.has('form-content.donorAlertMessage')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.donorAlertMessage"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                [
                                  _c(
                                    "md-checkbox",
                                    {
                                      model: {
                                        value: _vm.content.termsAndConditions,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.content,
                                            "termsAndConditions",
                                            $$v
                                          )
                                        },
                                        expression: "content.termsAndConditions"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Require Terms & Conditions acceptance from advisors"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-rule" },
                                [
                                  _c("label", [_vm._v("Terms & Conditions")]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:5000",
                                        expression: "'max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "formTermsAndConditionsMessage",
                                      placeholder: "Terms & Conditions"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.termsAndConditionsMessage = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value:
                                        _vm.content.termsAndConditionsMessage,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "termsAndConditionsMessage",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "content.termsAndConditionsMessage"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.formTermsAndConditionsMessage"
                                      ),
                                      expression:
                                        "errors.has('form-content.formTermsAndConditionsMessage')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.formTermsAndConditionsMessage"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                [
                                  _c("label", [_vm._v("Testimonial Consent")]),
                                  _vm._v(" "),
                                  _c("md-checkbox", {
                                    attrs: { name: "testimonialConsent" },
                                    model: {
                                      value: _vm.content.testimonialConsent,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "testimonialConsent",
                                          $$v
                                        )
                                      },
                                      expression: "content.testimonialConsent"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                [
                                  _c("label", [
                                    _vm._v("Testimonial Consent Message")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:5000",
                                        expression: "'max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "testimonialConsentMessage",
                                      placeholder: "Testimonial Consent Message"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.testimonialConsentMessage = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value:
                                        _vm.content.testimonialConsentMessage,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "testimonialConsentMessage",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "content.testimonialConsentMessage"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.testimonialConsentMessage"
                                      ),
                                      expression:
                                        "errors.has('form-content.testimonialConsentMessage')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.testimonialConsentMessage"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-rule" },
                                [
                                  _c("label", [
                                    _vm._v("Closed Request Message")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "required|max:5000",
                                        expression: "'required|max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "closeRequestMessage",
                                      placeholder: "Close Request Message"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.closeRequestMessage = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.closeRequestMessage,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "closeRequestMessage",
                                          $$v
                                        )
                                      },
                                      expression: "content.closeRequestMessage"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.closeRequestMessage"
                                      ),
                                      expression:
                                        "errors.has('form-content.closeRequestMessage')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.closeRequestMessage"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-rule" },
                                [
                                  _c("label", [
                                    _vm._v("Message on Snooze page")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "required|max:5000",
                                        expression: "'required|max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "snoozeMessage",
                                      placeholder: "Message on Snooze page"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.snoozeMessage = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.snoozeMessage,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "snoozeMessage",
                                          $$v
                                        )
                                      },
                                      expression: "content.snoozeMessage"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.snoozeMessage"
                                      ),
                                      expression:
                                        "errors.has('form-content.snoozeMessage')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.snoozeMessage"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-rule" },
                                [
                                  _c("label", [_vm._v("Resources")]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.continues",
                                        value: "max:5000",
                                        expression: "'max:5000'",
                                        modifiers: { continues: true }
                                      }
                                    ],
                                    attrs: {
                                      maxlength: _vm.maxWelcome,
                                      name: "resources",
                                      placeholder: "Resources"
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.resources = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.resources,
                                      callback: function($$v) {
                                        _vm.$set(_vm.content, "resources", $$v)
                                      },
                                      expression: "content.resources"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Member Thank You Page")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: false,
                                          regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_]*)?$/
                                        },
                                        expression:
                                          "{ required: false, regex: /^http(s?)\\:\\/\\/[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*(:(0-9)*)*(\\/?)([a-zA-Z0-9\\-\\.\\?\\,\\'\\/\\\\\\+&%\\$#_]*)?$/ }"
                                      }
                                    ],
                                    attrs: {
                                      name: "memberThankYou",
                                      placeholder: "Member Thank You Page"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.memberThankYou = _vm.sanitizeURL(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.memberThankYou,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "memberThankYou",
                                          $$v
                                        )
                                      },
                                      expression: "content.memberThankYou"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.memberThankYou"
                                      ),
                                      expression:
                                        "errors.has('form-content.memberThankYou')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.memberThankYou"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Advisor Thank You Page")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: false,
                                          regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_]*)?$/
                                        },
                                        expression:
                                          "{ required: false, regex: /^http(s?)\\:\\/\\/[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*(:(0-9)*)*(\\/?)([a-zA-Z0-9\\-\\.\\?\\,\\'\\/\\\\\\+&%\\$#_]*)?$/ }"
                                      }
                                    ],
                                    attrs: {
                                      name: "advisorThankYou",
                                      placeholder: "Advisor Thank You Page"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.content.advisorThankYou = _vm.sanitizeURL(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.advisorThankYou,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "advisorThankYou",
                                          $$v
                                        )
                                      },
                                      expression: "content.advisorThankYou"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.advisorThankYou"
                                      ),
                                      expression:
                                        "errors.has('form-content.advisorThankYou')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.advisorThankYou"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                [
                                  _c(
                                    "md-checkbox",
                                    {
                                      model: {
                                        value: _vm.content.profileValidation,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.content,
                                            "profileValidation",
                                            $$v
                                          )
                                        },
                                        expression: "content.profileValidation"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Profile validation on Thank You page"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("hr", {
                                staticClass: "dark-border m-left-5 mt-40 mb-40"
                              }),
                              _vm._v(" "),
                              _c("h3", { staticClass: "m-left-5 mb-20" }, [
                                _vm._v("Email Content")
                              ]),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v(
                                      "Email Footer (community.email_footer)"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    staticClass: "content-emailfooter",
                                    attrs: {
                                      name: "emailFooter",
                                      placeholder: "Email Footer",
                                      rows: 20
                                    },
                                    on: {
                                      blur: function($event) {
                                        _vm.content.emailFooter = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.emailFooter,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "emailFooter",
                                          $$v
                                        )
                                      },
                                      expression: "content.emailFooter"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has(
                                            "form-content.emailFooter"
                                          ),
                                          expression:
                                            "errors.has('form-content.emailFooter')"
                                        }
                                      ],
                                      staticClass: "error m-left-5"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errors.first(
                                            "form-content.emailFooter"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("hr", {
                                staticClass: "dark-border m-left-5 mt-40 mb-40"
                              }),
                              _vm._v(" "),
                              _c("h3", { staticClass: "m-left-5 mb-20" }, [
                                _vm._v("Invalid Member Message")
                              ]),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-community m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v(
                                      "Invalid Member Message (community.email)"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    staticClass: "content-invalidMemberMessage",
                                    attrs: {
                                      name: "invalidMemberMessage",
                                      placeholder: "Invalid Member Message"
                                    },
                                    on: {
                                      blur: function($event) {
                                        ;(_vm.content.invalidMemberMessage = _vm.sanitizeHtmlTemplate(
                                          $event.target.value
                                        )),
                                          _vm.labelValidate(
                                            "invalidMemberMessage"
                                          )
                                      }
                                    },
                                    model: {
                                      value: _vm.content.invalidMemberMessage,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.content,
                                          "invalidMemberMessage",
                                          $$v
                                        )
                                      },
                                      expression: "content.invalidMemberMessage"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "md-button",
                                {
                                  staticClass:
                                    "md-raised md-round md-accent m-left-5",
                                  attrs: { type: "submit" }
                                },
                                [_vm._v(_vm._s(_vm.saveContentText))]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7b3ff3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7b3ff3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/community/__CommunityContentSection.vue
// module id = null
// module chunks = 